import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const BGAPlacements = (props) => {
  const { label } = props;

  return (
    <TextComponent
      label={label}
      value="Not supported"
      inputClassName="text-danger"
      groupName={null}
      data={{ readOnly: true }} />
  );
};

BGAPlacements.defaultProps = {
  label: Spree.translations.parameters.bga,
  required: true,
  inputId: 'bga',
};


export default BGAPlacements;
